import hPaging from './src/h-paging'

hPaging.install = function (Vue) {
  Vue.component(hPaging.name, hPaging);
};

export default hPaging;